import React, { useState, useEffect } from "react";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import PasswordStrengthBar from "react-password-strength-bar";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import LoopIcon from "@mui/icons-material/Loop";
import axios from "axios";
import { showError, showSuccess } from "../../../toastify";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { connect } from "react-redux";

import { saveTrainingProvider } from "../../../../store/cpd/actions";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const MembershipRequestForm = (props) => {
  const {
    showDialog,
    setShowDialog,
    loading,
    programs,
    organizationTypes,
    countries,
    onSuccess,
    traingProviderAttachmentTypes,
    saveTrainingProvider,
  } = props;

  const [providerAttachments, setproviderAttachments] = useState([]);
  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);

  const convertToLower = (value) => {
    return value.toLowerCase();
  };

  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 3222528 ? true : false;
  };

  const [errors, setErrors] = useState({
    countryIdHasError: false,
    tinNumberHasError: false,
    institutionNameHasError: false,
    organizationTypeIdHasError: false,
    providerProgramsHasError: false,
    emailHasError: false,
    phoneHasError: false,
    passwordHasError: false,
    passwordRetypeHasError: false,
    emailOtpHasError: false,
    phoneOtpHasError: false,
    attachmentHasErrors: [],
    hasError: false,
  });

  const handleUploadedPDFFile = (event, document) => {
    setErrors({ ...errors, hasError: false });
    let pdfAttachment = event.target.files[0];

    if (convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf") {
      showError("File should be pdf format");
    } else if (isFileTooLarge(pdfAttachment)) {
      showError("Allowed file should not exceed 3MB");
    } else {
      const index = providerAttachments.findIndex(
        ({ id }) => id === document.id,
      );
      const attachments = [...providerAttachments];
      document.file = pdfAttachment;
      document.filename = pdfAttachment.name;

      const reader = new FileReader();

      reader.onload = (e) => {
        document.url = e.target.result;
      };

      reader.readAsDataURL(pdfAttachment);

      if (index < 0) attachments.push(document);
      else attachments[index] = document;

      setproviderAttachments(attachments);

      const errorIndex = errors.attachmentHasErrors.findIndex(
        (id) => id === document.id,
      );

      if (errorIndex >= 0) errors.attachmentHasErrors.splice(errorIndex, 1);
    }
  };

  // const [providerPrograms, setProviderPrograms] = useState([]);

  const [requestForm, setRequestForm] = useState({
    countryId: "RW",
    tinNumber: "",
    tinVerified: "",
    institutionName: "",
    acronym: "",
    organizationTypeId: "",
    email: "",
    phone: "",
    password: "",
    passwordRetype: "",
    emailOtp: "",
    phoneOtp: "",
  });

  useEffect(() => {
    setCountry(countries.find(({ id }) => id === "RW") || null);
  }, [countries]);

  const [confirmed, setConfirmed] = useState(false);

  const [country, setCountry] = useState(null);

  const [isPasswordStrong, setIsPasswordStrong] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const isRwanda = requestForm.countryId === "RW" || !requestForm.countryId;

  const [providerPrograms, setProviderPrograms] = useState([]);

  const verifyTinNumber = async () => {
    try {
      setRequestForm({
        ...requestForm,
        institutionName: "",
        acronym: "",
      });
      setVerifying(true);

      const { data } = await axios.get(
        `/api/cpd/verify-tin?tin=${requestForm.tinNumber}`,
      );

      setRequestForm({
        ...requestForm,
        tinVerified: data.verified,
        institutionName: data.institutionName || "",
        acronym: "",
      });

      setErrors({
        ...errors,
        institutionNameHasError: false,
        tinNumberHasError: false,
      });

      setVerifying(false);
    } catch (error) {
      setVerifying(false);
    }
  };

  const formErrors = () => {
    const error = {
      countryIdHasError: false,
      tinNumberHasError: false,
      institutionNameHasError: false,
      organizationTypeIdHasError: false,
      providerProgramsHasError: false,
      emailHasError: false,
      phoneHasError: false,
      passwordHasError: false,
      passwordRetypeHasError: false,
      emailOtpHasError: false,
      phoneOtpHasError: false,
      attachmentHasErrors: [],
      hasError: false,
    };

    if (!requestForm.countryId) {
      error.countryIdHasError = true;
      error.hasError = true;
    }

    if (!requestForm.tinNumber || (isRwanda && !requestForm.tinVerified)) {
      error.tinNumberHasError = true;
      error.hasError = true;
    }

    if (!requestForm.institutionName) {
      error.institutionNameHasError = true;
      error.hasError = true;
    }

    if (!requestForm.organizationTypeId) {
      error.organizationTypeIdHasError = true;
      error.hasError = true;
    }

    if (!providerPrograms.length) {
      error.providerProgramsHasError = true;
      error.hasError = true;
    }

    if (!requestForm.phone) {
      error.phoneHasError = true;
      error.hasError = true;
    }

    if (!requestForm.email) {
      error.emailHasError = true;
      error.hasError = true;
    }

    // if (!requestForm.password || !isPasswordStrong) {
    //   error.passwordHasError = true;
    //   error.hasError = true;
    // }

    // if (
    //   !requestForm.passwordRetype ||
    //   (!!requestForm.passwordRetype &&
    //     requestForm.passwordRetype !== requestForm.password)
    // ) {
    //   error.passwordRetypeHasError = true;
    //   error.hasError = true;
    // }

    traingProviderAttachmentTypes
      .filter(({ isActive }) => !!isActive)
      .forEach((doc) => {
        const document = providerAttachments.find(({ id }) => doc.id === id);

        if (!document && !!doc.isRequired) {
          error.attachmentHasErrors.push(doc.id);
        }
      });

    if (error.attachmentHasErrors.length) {
      error.hasError = true;
    }

    // console.log(error);

    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!showOtpDialog) setConfirmed(false);
  }, [requestForm, providerPrograms, providerAttachments]);

  const onSubmit = async () => {
    if (!formErrors()) {
      const tmpProviderPrograms = [];
      providerPrograms.forEach(({ id }) => tmpProviderPrograms.push(id));
      requestForm.email = (requestForm.email || "").trim();
      requestForm.phone = (requestForm.phone || "")
        .replace(/\s/g, "")
        .slice(-10);
      const formData = new FormData();
      const keys = Object.keys(requestForm);
      for (const key of keys) {
        if (requestForm.hasOwnProperty(key)) {
          formData.append(`${key}`, `${requestForm[key]}`);
        }
      }
      formData.append(`providerPrograms`, tmpProviderPrograms);

      formData.append(
        `providerAttachments`,
        JSON.stringify(providerAttachments.map((att) => att.id)),
      );

      providerAttachments.forEach((row, i) => {
        formData.append("files", row.file);
      });

      saveTrainingProvider(formData, () => {
        onClose();
      });
    }
  };

  const onClose = () => {
    setShowDialog(false);
  };
  return (
    <Dialog onClose={onClose} open={showDialog} fullWidth maxWidth="md">
      <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
        <span className="d-flex align-items-center mb-2">
          <Typography className="d-flex align-items-center text-primary">
            Training provider registration
          </Typography>
        </span>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div
          className="border rounded bg-light mt-3"
          style={{
            padding: "20px",
          }}
        >
          <div className={`row justify-content-center`}>
            <div className={`col-12 row border rounded bg-white p-3`}>
              <>
                <div className="col-4 text-left mt-2">
                  <Autocomplete
                    defaultValue={null}
                    value={country}
                    options={countries}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        {option.name}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={errors.countryIdHasError}
                        label="Country"
                        name="countryId"
                        placeholder="Country"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "countryId",
                        }}
                      />
                    )}
                    onChange={(event, selected) => {
                      setCountry(selected || null);

                      setRequestForm({
                        ...requestForm,
                        countryId: selected?.id || "",
                        tinNumber: "",
                        tinVerified: "",
                        institutionName: "",
                        acronym: "",
                      });

                      setErrors({
                        ...errors,
                        countryIdHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                </div>

                <div className="col-8 text-left mt-2">
                  <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{ mb: 1 }}
                    error={
                      (isRwanda && requestForm.tinVerified === false) ||
                      errors.tinNumberHasError
                    }
                  >
                    <InputLabel
                      htmlFor="tinNumber"
                      className="d-inline-flex align-items-center"
                    >
                      {isRwanda ? "TIN Number" : "Registration Number"}
                      {isRwanda && requestForm.tinVerified !== "" && (
                        <span
                          className={`ml-1 badge badge-${
                            requestForm.tinVerified === true
                              ? "success"
                              : "danger"
                          } `}
                        >
                          {requestForm.tinVerified === true ? (
                            <>
                              <TaskAltIcon style={{ fontSize: "14px" }} />{" "}
                              Verified
                            </>
                          ) : (
                            <>
                              <ReportProblemIcon style={{ fontSize: "14px" }} />{" "}
                              Error
                            </>
                          )}
                        </span>
                      )}
                    </InputLabel>
                    <OutlinedInput
                      readOnly={showOtpDialog}
                      id="tinNumber"
                      placeholder={
                        isRwanda ? "TIN Number" : "Registration Number"
                      }
                      name="tinNumber"
                      type="text"
                      value={requestForm.tinNumber || ""}
                      onChange={(e) => {
                        setRequestForm({
                          ...requestForm,
                          tinNumber: e.target.value || "",
                          tinVerified: "",
                          // Clear name if rwanda and not admin to force re-verify?
                          // Actually for admin we might want to keep it simple
                          institutionName: isRwanda
                            ? ""
                            : requestForm.institutionName,
                        });

                        setErrors({
                          ...errors,
                          tinNumberHasError: false,
                          hasError: false,
                        });
                      }}
                      endAdornment={
                        isRwanda && (
                          <InputAdornment position="end">
                            <Button
                              type="button"
                              disabled={
                                !requestForm?.tinNumber ||
                                verifying ||
                                showOtpDialog
                              }
                              startIcon={
                                <LoopIcon
                                  className={`${verifying ? "spinner" : ""} `}
                                />
                              }
                              color="primary"
                              size="large"
                              fullWidth
                              variant="contained"
                              onClick={() => verifyTinNumber()}
                            >
                              Verify
                            </Button>
                          </InputAdornment>
                        )
                      }
                      label={isRwanda ? "TIN Number" : "Registration Number"}
                    />
                  </FormControl>
                </div>
                <div className="col-12 text-left mt-2">
                  <TextField
                    required
                    style={isRwanda ? { backgroundColor: "#e9ecef" } : {}}
                    InputProps={{
                      readOnly: !!isRwanda,
                    }}
                    fullWidth
                    name="institutionName"
                    label="Institution Name"
                    placeholder="Institution Name"
                    variant="outlined"
                    value={requestForm.institutionName || ""}
                    onChange={(e) => {
                      if (!isRwanda) {
                        setRequestForm({
                          ...requestForm,
                          institutionName: e.target.value,
                        });
                        setErrors({
                          ...errors,
                          institutionNameHasError: false,
                          hasError: false,
                        });
                      }
                    }}
                    error={errors.institutionNameHasError}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    type="text"
                    fullWidth
                    name="acronym"
                    label="Acronym"
                    placeholder="Acronym"
                    variant="outlined"
                    value={requestForm.acronym}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        acronym: event.target.value,
                      });
                    }}
                    InputProps={{
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>

                <div className="col-12 text-left mt-3">
                  <FormControl
                    required
                    fullWidth
                    error={errors.organizationTypeIdHasError}
                  >
                    <InputLabel id="organizationType">
                      Organization type
                    </InputLabel>
                    <Select
                      readOnly={showOtpDialog}
                      labelId="organizationType"
                      id="organizationTypeSelect"
                      value={requestForm.organizationTypeId}
                      label="Organization type"
                      onChange={(event) => {
                        setRequestForm({
                          ...requestForm,
                          organizationTypeId: event.target.value,
                        });

                        setErrors({
                          ...errors,
                          organizationTypeIdHasError: false,
                          hasError: false,
                        });
                      }}
                    >
                      {organizationTypes
                        .filter(({ isActive }) => !!isActive)
                        ?.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-12 text-left mt-3">
                  <Autocomplete
                    readOnly={showOtpDialog}
                    fullWidth
                    multiple
                    id="providerPrograms"
                    name="providerPrograms"
                    options={
                      programs.filter(({ isActive }) => !!isActive) || []
                    }
                    value={providerPrograms}
                    // disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={errors.providerProgramsHasError}
                        required
                        {...params}
                        label="Areas of intervention"
                        placeholder="Select areas of intervention"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "providerPrograms",
                        }}
                      />
                    )}
                    onChange={(event, program) => {
                      setProviderPrograms(program || []);

                      setErrors({
                        ...errors,
                        providerProgramsHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    error={errors.phoneHasError}
                    required
                    type="text"
                    fullWidth
                    name="phone"
                    label="Phone"
                    placeholder="07XXXXXXXX"
                    variant="outlined"
                    value={requestForm.phone}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        phone: event.target.value,
                      });

                      setErrors({
                        ...errors,
                        phoneHasError: false,
                        hasError: false,
                      });
                    }}
                    InputProps={{
                      autoComplete: "phone",
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>
                <div className="col-12 text-left mt-3">
                  <TextField
                    error={errors.emailHasError}
                    required
                    type="email"
                    fullWidth
                    name="email"
                    label="Email"
                    placeholder="Email"
                    variant="outlined"
                    value={requestForm.email}
                    onChange={(event) => {
                      setRequestForm({
                        ...requestForm,
                        email: event.target.value,
                      });

                      setErrors({
                        ...errors,
                        emailHasError: false,
                        hasError: false,
                      });
                    }}
                    InputProps={{
                      autoComplete: "email",
                      readOnly: showOtpDialog,
                    }}
                  />
                </div>

                <div className="col-12 mt-3">
                  <fieldset
                    className={`row mx-0 p-3 rounded border ${
                      errors.attachmentHasErrors.length ? "border-danger" : ""
                    }`}
                  >
                    <legend
                      className={`col-12 w-auto px-2 text-primary`}
                      style={{
                        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                        fontWeight: 400,
                        fontSize: "0.82rem",
                        lineHeight: "1em",
                        letterSpacing: "0.00938em",
                      }}
                    >
                      Required documents
                    </legend>

                    {traingProviderAttachmentTypes
                      .filter(({ isActive }) => !!isActive)
                      .map((document, index) => (
                        <DocumentItem
                          error={errors.attachmentHasErrors.find(
                            (err) => err === index + 1,
                          )}
                          disabled={showOtpDialog}
                          key={document.id}
                          document={document}
                          providerAttachments={providerAttachments}
                          setproviderAttachments={setproviderAttachments}
                          setShowUploadedDocument={setShowUploadedDocument}
                          setUploadedDocument={setUploadedDocument}
                          handleUploadedPDFFile={handleUploadedPDFFile}
                        />
                      ))}
                  </fieldset>
                </div>

                {!!errors.hasError && (
                  <div className="col-12 mt-3">
                    <Alert
                      className="text-center border border-danger"
                      // icon={false}
                      severity="error"
                      sx={{
                        borderRadius: "8px",
                        "& .MuiAlert-message": {
                          width: "100%",
                        },
                      }}
                    >
                      Please complete all the required fields above.
                    </Alert>
                  </div>
                )}
                <div className="col-12 mt-3">
                  <Button
                    disabled={loading}
                    onClick={() => {
                      onSubmit();
                    }}
                    size="large"
                    fullWidth
                    variant="contained"
                    color={"primary"}
                    type="button"
                  >
                    Submit
                  </Button>
                </div>
              </>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = ({
  user,
  loading,
  countries,
  traingProviderAttachmentTypes,
  programs,
  organizationTypes,
}) => {
  return {
    user,
    loading,
    countries,
    traingProviderAttachmentTypes,
    programs,
    organizationTypes,
  };
};

export default connect(mapStateToProps, { saveTrainingProvider })(
  MembershipRequestForm,
);

const DocumentItem = (props) => {
  const {
    document,
    providerAttachments,
    setproviderAttachments,
    setShowUploadedDocument,
    setUploadedDocument,
    handleUploadedPDFFile,
    disabled,
    error,
  } = props;

  // anchorEl logic removed as menu is commented out in original file

  return (
    <>
      <div className="col-12">
        <fieldset className={`form-groupborder `}>
          <legend
            className={`w-auto px-2 d-flex align-items-center ${
              error ? "text-danger" : ""
            } `}
            style={{
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 400,
              fontSize: "0.82rem",
              lineHeight: "1em",
              letterSpacing: "0.00938em",
              color: `rgba(0, 0, 0, 0.6)`,
            }}
          >
            {document.id}.{" "}
            <span className="ml-1">
              {document.name}{" "}
              {!document.isRequired && (
                <span className="ml-1 text-danger">(Optional)</span>
              )}
            </span>
          </legend>
          <div className="form-group1 mb-3">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fas fa-paperclip"></i>
                </span>
              </div>
              {providerAttachments.find(
                (doc) => document.id === doc.id && !!doc.filename,
              ) ? (
                <div
                  className="form-control"
                  style={{
                    backgroundColor: "rgb(229, 246, 253)",
                    color: "#007bff",
                  }}
                >
                  <span
                    className="d-inline-block text-truncate"
                    style={{ cursor: "pointer", maxWidth: "90%" }}
                    onClick={() => {
                      if (!disabled) {
                        setShowUploadedDocument(true);
                        setUploadedDocument({
                          name: document.name,
                          url: providerAttachments.find(
                            (doc) => document.id === doc.id && !!doc.filename,
                          ).url,
                        });
                      }
                    }}
                  >
                    {
                      providerAttachments.find(
                        (doc) => document.id === doc.id && !!doc.filename,
                      ).filename
                    }
                  </span>

                  <IconButton
                    disabled={disabled}
                    size="small"
                    onClick={(e) => {
                      const tmpDocuments = [...providerAttachments];
                      const index = tmpDocuments.findIndex(
                        ({ id }) => id === document.id,
                      );
                      if (index >= 0) tmpDocuments.splice(index, 1);
                      setproviderAttachments(tmpDocuments);
                    }}
                    style={{
                      marginTop: "-5px",
                      marginRight: "-10px",
                    }}
                    color="error"
                    className="float-right"
                    aria-label="view"
                  >
                    <span className="material-icons mr-1">delete_forever</span>
                  </IconButton>
                </div>
              ) : (
                <>
                  <input
                    disabled={disabled}
                    type="file"
                    name="file"
                    style={{
                      padding: 0,
                      paddingLeft: "3px",
                      paddingTop: "3px",
                      paddingBottom: "3px",
                    }}
                    className={`form-control ${error ? "text-danger" : ""}`}
                    accept="application/pdf"
                    placeholder="Select pdf file"
                    onChange={(e) => handleUploadedPDFFile(e, document)}
                  />
                </>
              )}
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};
